var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"component-custom"},[_c('p',[_vm._v("custom component")]),_c('h1',{domProps:{"innerHTML":_vm._s(_vm.content.title)}}),_c('p',{domProps:{"innerHTML":_vm._s(_vm.content.description)}})])}
var staticRenderFns = []

export { render, staticRenderFns }